module.exports = __webpack_public_path__ + "static/media/profile-picture-5.baf7bf75.jpg";